import React, { Component } from 'react';
import Layout from '../../components/Layout';
import Joinwebinar from './joinwebinar';
import Mixedwebinar from './mixedwebinar';
import Mailing from './mailing';
import Startjourney from './startjourney';
import './css/index.css';

class Webinar extends Component {
  render() {
    return (
      <Layout {...this.props}>
        <div className="webinar">
          <Joinwebinar />
          <Mixedwebinar />
          <Mailing />
          <Startjourney />
        </div>
      </Layout>
    );
  }
}

export default Webinar;
